import type { User } from 'features/auth';
import { isOrganizationAdminProfile, isSuperAdmin } from '../utils';

export const canViewChannelsSection = ({
  organizationId,
  viewer: { railsUserData },
}: {
  organizationId?: string;
  viewer: User;
}) =>
  isSuperAdmin({ viewer: railsUserData }) ||
  Boolean(organizationId && isOrganizationAdminProfile({ organizationId, viewer: railsUserData }));
